import Vue from 'vue';
import Vuex from 'vuex';
import api from '@/utils/api';
const CONST = require('./utils/const.js');

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    layout: localStorage.getItem('user-token') ? 'default' : 'empty',
    token: localStorage.getItem('user-token') || '',
    accountName: localStorage.getItem('user-name') ? localStorage.getItem('user-name') : '',
    status: '',
    permissions: [],
    KeepAlive: '',
    rootAPI: CONST.BACK_URL,
    addProject: null,
    preloaderStatus: false,
    user: {
      UserFormaterData: {},
      TimeZone: '',
    },
    userRole: '',
    reports: {
      dataSendCustomer: {
        ReportId: '',
        ReportType: '',
        ErrorConclusionList: [],
      },
    },

    preloaderShow: true,
    showMenu: true,
    showFilter: true,
    showSettingsMenu: false,
    filters: {
      name: null,
      url: null,
    },

    showSessionBlock: false,
    dictionaries: {
      languages: Array(),
      industry: Array(),
      industry_tree: Array(),
      countries: Array(),
      qa_methods: Array(),
      document_types: Array(),
      user_titles: Array(),
      account_types: Array(),
    },

    mainAppLogo: {
      selectedLogo: '/img/logo_white.png',
      currentLogos: [
        '/img/logo_white.png',
        'http://logosolusa.com/wp-content/uploads/parser/Random-Logo-1.png',
      ],
    },
  },
  getters: {
    layout: (state) => state.layout,
    isAuthenticated: (state) => !!state.token,
    authStatus: (state) => state.status,
    accountName: (state) => state.accountName,
    rootAPI: (state) => state.rootAPI,
    addProject: (state) => state.addProject,
    filters: (state) => state.filters,
    permissions: (state) => state.permissions,
    preloaderStatus: (state) => state.preloaderStatus,
    token: (state) => state.token,
    getConnection: (state) => state.KeepAlive,
    user: (state) => state.user,
    getDataSendCustomer: (state) => state.reports.dataSendCustomer,
    userRole: (state) => state.userRole,
    preloaderShow: (state) => state.preloaderShow,
    showMenu: (state) => state.showMenu,
    showFilter: (state) => state.showFilter,
    showSettingsMenu: (state) => state.showSettingsMenu,
    showSessionBlock: (state) => state.showSessionBlock,
    mainAppLogo: (state) => state.mainAppLogo,
  },
  actions: {
    async LAZY_GET_DICTONARIES({
      dispatch,
    }) {
      const dictonariesArr = [
        'GET_LANGUAGES',
        'GET_INDUSTRY',
        'GET_COUNTRIES',
        'GET_QA_METHODS',
        'GET_DOCUMENT_TYPES',
        'GET_USER_TITLES',
        'GET_INDUSTRY_TREE',
      ];
      for (let i = 0; i < dictonariesArr.length; i++) {
        await Promise.all([
          dispatch(dictonariesArr[i]),
          new Promise((res) => setTimeout(res, 5000)),
        ]);
      }
    },
    SET_DATE_FORMAT: ({
      commit,
    }, format) => {
      commit('SET_DATE_FORMAT', format);
    },
    SET_TIMEZONE: ({
      commit,
    }, tz) => {
      commit('SET_TIMEZONE', tz);
    },
    SET_USER_ROLE({
      commit,
    }) {
      if (localStorage.getItem('user-token') !== null) {
        const userToken = localStorage.getItem('user-token') || '';
        const parseToken = JSON.parse(window.atob(userToken.split('.')[1].replace('-', '+').replace('_', '/')));

        commit('SET_USER_ROLE', parseToken.role_name);
      }
    },
    SET_USER: ({
      commit,
      dispatch,
    }, user) => {
      if (user.UserFormaterData !== null) {
        user.UserFormaterData = JSON.parse(user.UserFormaterData)[0];
      } else {
        user.UserFormaterData = {
          DateFormat: 'MM.DD.YYYY',
          DatetimeFormat: 'MM.DD.YYYY HH:mm',
          UserTimezone: true,
        };
      }
      dispatch('SET_USER_ROLE');
      commit('SET_USER', user);
    },
    SET_FILTERS: ({
      commit,
    }, filter) => {
      commit('SET_FILTERS', filter);
    },
    CLEAR_FILTERS({
      commit,
    }) {
      commit('CLEAR_FILTERS');
    },
    ADD_PROJECT: ({
      commit,
    }, project) => {
      commit('ADD_PROJECT', project);
    },
    COUNT_SIZE({
      commit,
    }, size) {
      commit('COUNT_SIZE', size);
    },
    CLEAR_PROJECT({
      commit,
    }) {
      commit('CLEAR_PROJECT');
    },
    CHANGE_PERMISSIONS({
      commit,
    }, permissions) {
      commit('CHANGE_PERMISSIONS', permissions);
    },
    CHANGE_ALIVE({
      commit,
    }, KeepAlive) {
      commit('CHANGE_ALIVE', KeepAlive);
    },
    UPLOAD_PERMISSIONS({
      commit,
    }) {
      const permissions = CONST.parseToken();
      commit('CHANGE_PERMISSIONS', JSON.parse(permissions.rightSlugs));
    },
    CHECK_ALIVE({
      commit,
    }) {
      const token = localStorage.getItem('refresh-token') || '';
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const connection = JSON.parse(window.atob(base64));
      commit('CHANGE_ALIVE', connection.keep_alive);
    },
    AUTH_REQUEST: ({
      commit,
    }, data) => {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST');
        const token = data.accessToken;
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        const userPermissions = JSON.parse(window.atob(base64));

        localStorage.setItem('user-token', data.accessToken);
        localStorage.setItem('refresh-token', data.refreshToken);
        localStorage.setItem('user-name', userPermissions.unique_name);

        commit('AUTH_SUCCESS', {
          token: token,
          username: userPermissions.unique_name,
        });
        commit('SET_LAYOUT', 'default');
        resolve(data);
      });
    },
    LOGOUT({
      commit,
    }) {
      return new Promise((resolve, reject) => {
        commit('LOGOUT');
        commit('SET_LAYOUT', 'empty');
        localStorage.removeItem('user-token');
        localStorage.removeItem('user-name');
        localStorage.removeItem('refresh-token');
        resolve();
      });
    },
    SHOW_SESSION_BLOCK({
      commit,
    }, data) {
      commit('SHOW_SESSION_BLOCK', data);
    },
    SELECT_ERROR({
      commit,
    }, error) {
      commit('SELECT_ERROR', error);
    },
    SELECT_COMMENT({
      commit,
    }, error) {
      commit('SELECT_COMMENT', error);
    },
    REPORTS_DATA_CUSTOMER_UPDATE({
      commit,
    }, data) {
      commit('REPORTS_DATA_CUSTOMER_UPDATE', data);
    },
    SHOW_PRELOADER({
      commit,
    }, data) {
      commit('SHOW_PRELOADER', data);
    },
    SHOW_MENU({
      commit,
    }, data) {
      commit('SHOW_MENU', data);
    },
    SHOW_SETTINGS_MENU({
      commit,
    }, data) {
      commit('SHOW_SETTINGS_MENU', data);
    },
    SHOW_FILTER({
      commit,
    }, payload) {
      commit('SHOW_FILTER', payload);
    },
    GET_LANGUAGES({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.languages.length > 0) {
          res(state.dictionaries.languages);
        } else {
          api.getLanguage().then((resp) => {
            if (resp.data.length > 0) {
              commit('SET_LANGUAGES', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_INDUSTRY({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.industry.length > 0) {
          res(state.dictionaries.industry);
        } else {
          api.getIndustry().then((resp) => {
            if (resp.data.length > 0) {
              commit('SET_INDUSTRY', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_COUNTRIES({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.countries.length > 0) {
          res(state.dictionaries.countries);
        } else {
          api.registration.getAllCountries().then((resp) => {
            if (resp.data.length > 0) {
              commit('SET_COUNTRIES', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_QA_METHODS({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.qa_methods.length > 0) {
          res(state.dictionaries.qa_methods);
        } else {
          api.getQaMethods().then((resp) => {
            if (resp.data.Data.length > 0) {
              commit('SET_QA_METHODS', resp.data.Data);
              res(resp.data.Data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_DOCUMENT_TYPES({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.document_types.length > 0) {
          res(state.dictionaries.document_types);
        } else {
          api.getTextCategory().then((resp) => {
            if (resp.data.length > 0) {
              commit('SET_DOCUMENT_TYPES', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_USER_TITLES({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.user_titles.length > 0) {
          res(state.dictionaries.user_titles);
        } else {
          api.user.getTitle().then((resp) => {
            if (resp.status === 200) {
              commit('SET_USER_TITLES', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_INDUSTRY_TREE({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.industry_tree.length > 0) {
          res(state.dictionaries.industry_tree);
        } else {
          api.getIndustryThree().then((resp) => {
            if (resp.status === 200) {
              commit('SET_INDUSTRY_TREE', resp.data);
              res(resp.data);
            } else {
              res(Array());
            }
          });
        }
      });
    },
    GET_ACCOUNT_TYPES({
      state,
      commit,
    }) {
      return new Promise((res) => {
        if (state.dictionaries.account_types.length > 0) {
          res(state.dictionaries.account_types);
        } else {
          api.user.getAccounts().then((resp) => {
            if (resp.data.Status) {
              commit('SET_ACCOUNT_TYPES', resp.data.Data);
              res(resp.data.Data);
            } else {
              res(Array());
            }
          });
        }
      });
    },

    EDIT_LOGO_LIST({
      commit,
    }, payload) {
      if (payload.type === 'add') {
        commit('ADD_LOGO_TO_LOGO_LIST', payload.image);
      } else if (payload.type === 'remove') {
        commit('REMOVE_LOGO_FROM_LOGO_LIST', payload.image);
      }
    },
    SET_LOGO({
      commit,
    }, payload) {
      commit('SET_MAIN_APP_LOGO', payload);
    },
  },
  mutations: {
    SET_DATE_FORMAT(state, format) {
      state.user.UserFormaterData = format;
    },
    SET_TIMEZONE(state, tz) {
      state.user.TimeZone = tz;
    },
    SET_USER_ROLE(state, data) {
      state.userRole = data;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_FILTERS(state, filters) {
      state.filters.name = filters.name;
      state.filters.url = filters.url;
    },
    CLEAR_FILTERS(state) {
      state.filters = {
        name: null,
        url: null,
      };
    },
    ADD_PROJECT(state, project) {
      state.addProject = project;
    },
    CLEAR_PROJECT(state) {
      state.addProject = null;
    },
    SET_LAYOUT(state, layout) {
      state.layout = layout;
    },
    AUTH_REQUEST(state) {
      state.status = 'loading';
    },
    AUTH_SUCCESS(state, data) {
      state.status = 'success';
      state.accountName = data.username;
      state.token = data.token;
    },
    AUTH_ERROR(state) {
      state.status = 'error';
    },
    LOGOUT(state) {
      state.status = '';
    },
    CHANGE_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    CHANGE_ALIVE(state, KeepAlive) {
      state.KeepAlive = KeepAlive;
    },
    // For reports
    REPORTS_DATA_CUSTOMER_UPDATE(state, data) {
      state.reports.dataSendCustomer = data;
    },
    // General preloader
    SHOW_PRELOADER(state, data) {
      state.preloaderShow = data;
    },
    // Left menu
    SHOW_MENU(state, data) {
      state.showMenu = data;
    },
    // Admin menu
    SHOW_SETTINGS_MENU(state, data) {
      state.showSettingsMenu = data;
    },
    // Session block info on login page
    SHOW_SESSION_BLOCK(state, data) {
      state.showSessionBlock = data;
    },
    // Filter on report, task, project page
    SHOW_FILTER(state, data) {
      state.showFilter = data;
    },
    SET_LANGUAGES(state, data) {
      state.dictionaries.languages = data;
    },
    SET_INDUSTRY(state, data) {
      state.dictionaries.industry = data;
    },
    SET_COUNTRIES(state, data) {
      state.dictionaries.countries = data;
    },
    SET_QA_METHODS(state, data) {
      state.dictionaries.qa_methods = data;
    },
    SET_DOCUMENT_TYPES(state, data) {
      state.dictionaries.document_types = data;
    },
    SET_USER_TITLES(state, data) {
      state.dictionaries.user_titles = data;
    },
    SET_INDUSTRY_TREE(state, data) {
      state.dictionaries.industry_tree = data;
    },
    SET_ACCOUNT_TYPES(state, data) {
      state.dictionaries.account_types = data;
    },
    // set app logo
    ADD_LOGO_TO_LOGO_LIST(state, payload) {
      state.mainAppLogo.currentLogos = [...state.mainAppLogo.currentLogos, payload];
    },
    REMOVE_LOGO_FROM_LOGO_LIST(state, {
      idx,
      img,
    }) {
      if (state.mainAppLogo.currentLogos.length < 2) {
        throw new Error('logo list can not be empty!');
      } else {
        state.mainAppLogo.currentLogos = [...state.mainAppLogo.currentLogos.slice(0, idx), ...state.mainAppLogo.currentLogos.slice(idx + 1)];
        if (state.mainAppLogo.selectedLogo === img) {
          state.mainAppLogo.selectedLogo = '';
          state.mainAppLogo.selectedLogo = state.mainAppLogo.currentLogos[0];
        }
      }
    },
    SET_MAIN_APP_LOGO(state, payload) {
      state.mainAppLogo.selectedLogo = payload;
    },
  },
});
